import SwitchBody from "./switch-body";
import { CheckLogin, DetectBrowser, UseLocalStorage } from "../index";
import React, { useState, useEffect, useCallback, useRef } from "react";
import {
  Header,
  Footer,
  Dashboard,
  LockPage,
  SelectApi,
  UserBar,
} from "../../shared/index";

function Render(props) {
  const [lock, setLock] = useState(false);
  const [token, setToken] = UseLocalStorage("Token", null);
  // const [token,setToken]=useState(()=>{console,log('hhhhhhhhhhh')})
  const [login, setLogin] = useState(true);
  const [expire, setExpire] = UseLocalStorage("Expire", new Date());
  const [lastLogin, setLastLogin] = UseLocalStorage(
    "LastLogin",
    new Date().toLocaleString()
  );
  const openLock = useCallback(() => {
    setLock(true);
  }, [setLock]);
  const [searchData, setSearchData] = useState({
    CustomerSearchResult: [],
    CountCustomerSearchResult: 0,
  });

  const [search, setSearch] = useState(false);
  const [searchFilter, setSearchFilter] = useState([0]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedPageIndex, setSelectedPageIndex] = useState(1);
  const [searchPages, setSearchPages] = useState([]);
  const [userId, setUserId] = useState(null);
  const [api, setApi] = UseLocalStorage("UseLocalAPi", false);
  const previousValues = useRef({ lastLogin, token });
  const [userBarAxisX, setUserBarAxisX] = UseLocalStorage("AxisX", 20);
  const [userBarAxisY, setUserBarAxisY] = UseLocalStorage("AxisY", 5);

  useCallback(() => {
    CheckLogin(expire, lastLogin, setLogin, token, previousValues);
    DetectBrowser(openLock);
  }, [expire, lastLogin, token, openLock]);

  useEffect(() => {
    CheckLogin(expire, lastLogin, setLogin, token, previousValues);
    DetectBrowser(openLock);
  }, [expire, lastLogin, token, openLock]);


  return (
    <>
      {lock ? (
        <>
          {window.location.hostname === "localhost" ||
            window.location.hostname === "127.0.0.1" ? (
            <SelectApi api={api} setApi={setApi}></SelectApi>
          ) : (
            ""
          )}
          <Header login={login} />
          {userId && (
            <UserBar
              userId={userId}
              token={token}
              axisX={userBarAxisX}
              setAxisX={setUserBarAxisX}
              axisY={userBarAxisY}
              setAxisY={setUserBarAxisY}
            ></UserBar>
          )}
          <Dashboard search={search} login={login} type={props.type} />
          <SwitchBody
            login={login}
            token={token}
            userId={userId}
            type={props.type}
            setLogin={setLogin}
            setToken={setToken}
            setSearch={setSearch}
            setExpire={setExpire}
            setUserId={setUserId}
            searchTerm={searchTerm}
            searchData={searchData}
            searchPages={searchPages}
            searchFilter={searchFilter}
            setLastLogin={setLastLogin}
            setSearchTerm={setSearchTerm}
            setSearchData={setSearchData}
            setSearchPages={setSearchPages}
            setSearchFilter={setSearchFilter}
            selectedPageIndex={selectedPageIndex}
            setSelectedPageIndex={setSelectedPageIndex}
            data={props.data}
          />
        </>
      ) : (
        <LockPage></LockPage>
      )}
      <Footer />
    </>
  );
}
export default Render;
